import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { onValue, get } from "firebase/database";

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef,
      fareRulesRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
        return {
            latitude: point[0],
            longitude: point[1]
        }
    });
    
    onValue(settingsRef, async settingdata => {
      let settings = settingdata.val();
      let fareRules = [];
      try {
        const fareRulesSnap = await get(fareRulesRef);
        const fareRulesVal = fareRulesSnap.val();
        fareRules = fareRulesVal ? Object.keys(fareRulesVal).map(key => ({ ...fareRulesVal[key], id: key })) : [];
      } catch (error) {
        fareRules = [];
      }
      let distance = settings.convert_to_mile? (res.distance_in_km / 1.609344) : res.distance_in_km;

     let {
        totalCost,
        grandTotal,
        convenience_fees,
        baseFareBeforeAdjustments,
        adjustmentTotal,
        riderAdjustmentShare,
        adminAdjustmentShare,
        platformFeeTotal,
        fareAdjustments
      } = FareCalculator(
        distance,
        res.time_in_secs,
        bookingData.carDetails,
        bookingData.instructionData,
        settings.decimal,
        fareRules,
        { timestamp: bookingData.tripdate || Date.now() }
      );
     
      dispatch({
        type: FETCH_ESTIMATE_SUCCESS,
        payload: {
          pickup:bookingData.pickup,
          drop:bookingData.drop,
          carDetails:bookingData.carDetails,
          instructionData: bookingData.instructionData,
          estimateDistance: parseFloat(parseFloat(distance).toFixed(settings.decimal)),
          fareCost: totalCost ? parseFloat(parseFloat(totalCost).toFixed(settings.decimal)) : 0,
          estimateFare: grandTotal ? parseFloat(parseFloat(grandTotal).toFixed(settings.decimal)) : 0,
          estimateTime:res.time_in_secs,
          convenience_fees: convenience_fees ? parseFloat(parseFloat(convenience_fees).toFixed(settings.decimal)) : 0,
          baseFareBeforeAdjustments: baseFareBeforeAdjustments ? parseFloat(parseFloat(baseFareBeforeAdjustments).toFixed(settings.decimal)) : 0,
          adjustmentTotal: adjustmentTotal ? parseFloat(parseFloat(adjustmentTotal).toFixed(settings.decimal)) : 0,
          riderAdjustmentShare: riderAdjustmentShare ? parseFloat(parseFloat(riderAdjustmentShare).toFixed(settings.decimal)) : 0,
          adminAdjustmentShare: adminAdjustmentShare ? parseFloat(parseFloat(adminAdjustmentShare).toFixed(settings.decimal)) : 0,
          platformFeeTotal: platformFeeTotal ? parseFloat(parseFloat(platformFeeTotal).toFixed(settings.decimal)) : 0,
          fareAdjustments: fareAdjustments || [],
          waypoints: waypoints,
          previewOnly: bookingData.previewOnly === true
        },
      });
    }, {onlyOnce:true});
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
